export enum AppLanguage {
  English = 'en',
  German = 'de',
  Spanish = 'es'
}

export const appLanguages = Object.values(AppLanguage);
